export default {
    props: {
        modalPreventScroll: {
            type: Boolean,
            default: undefined,
            kComposite: 'modal.preventScroll'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dialog-vue-wrapper/src/KendoDialog/Modal.js